import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export var useModalControl = function useModalControl() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDescriptionModalOpen = _React$useState2[0],
    toggleDescriptionModal = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isConfirmationModalOpen = _React$useState4[0],
    toggleConfirmationModal = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isFetchingModalOpen = _React$useState6[0],
    toggleFetchingModal = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isErrorModalOpen = _React$useState8[0],
    toggleErrorModal = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAlreadyRegisteredModalOpen = _React$useState10[0],
    toggleAlreadyRegisteredModal = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isRedirectModalOpen = _React$useState12[0],
    toggleRedirectModal = _React$useState12[1];
  var openDescriptionModal = React.useCallback(function () {
    return toggleDescriptionModal(true);
  }, []);
  var openConfirmatioModal = React.useCallback(function () {
    return toggleConfirmationModal(true);
  }, []);
  var openFetchingModal = React.useCallback(function () {
    return toggleFetchingModal(true);
  }, []);
  var openErrorModal = React.useCallback(function () {
    return toggleErrorModal(true);
  }, []);
  var openAlreadyRegisteredModal = React.useCallback(function () {
    return toggleAlreadyRegisteredModal(true);
  }, []);
  var openRedirectModal = React.useCallback(function () {
    return toggleRedirectModal(true);
  }, []);
  var closeDescriptionModal = React.useCallback(function () {
    return toggleDescriptionModal(false);
  }, []);
  var closeConfirmatioModal = React.useCallback(function () {
    return toggleConfirmationModal(false);
  }, []);
  var closeFetchingModal = React.useCallback(function () {
    return toggleFetchingModal(false);
  }, []);
  var closeErrorModal = React.useCallback(function () {
    return toggleErrorModal(false);
  }, []);
  var closeAlreadyRegisteredModal = React.useCallback(function () {
    return toggleAlreadyRegisteredModal(false);
  }, []);
  var closeRedirectModal = React.useCallback(function () {
    return toggleRedirectModal(false);
  }, []);
  return {
    isDescriptionModalOpen: isDescriptionModalOpen,
    isConfirmationModalOpen: isConfirmationModalOpen,
    isFetchingModalOpen: isFetchingModalOpen,
    isErrorModalOpen: isErrorModalOpen,
    isAlreadyRegisteredModalOpen: isAlreadyRegisteredModalOpen,
    isRedirectModalOpen: isRedirectModalOpen,
    openDescriptionModal: openDescriptionModal,
    openConfirmatioModal: openConfirmatioModal,
    openFetchingModal: openFetchingModal,
    openErrorModal: openErrorModal,
    openAlreadyRegisteredModal: openAlreadyRegisteredModal,
    openRedirectModal: openRedirectModal,
    closeDescriptionModal: closeDescriptionModal,
    closeConfirmatioModal: closeConfirmatioModal,
    closeFetchingModal: closeFetchingModal,
    closeErrorModal: closeErrorModal,
    closeAlreadyRegisteredModal: closeAlreadyRegisteredModal,
    closeRedirectModal: closeRedirectModal
  };
};